"use strict";
var apply = require("../internals/function-apply");
var toIndexedObject = require("../internals/to-indexed-object");
var toIntegerOrInfinity = require("../internals/to-integer-or-infinity");
var lengthOfArrayLike = require("../internals/length-of-array-like");
var arrayMethodIsStrict = require("../internals/array-method-is-strict");
var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict("lastIndexOf");
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;
module.exports = FORCED ? function lastIndexOf(searchElement) {
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  if (length === 0) return -1;
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (; index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;
